import { Spin } from 'antd';
import React, { FC, memo } from 'react';
import StyledWrapper from './styles';

const Loading: FC = () => {
  return (
    <StyledWrapper>
      <Spin />
    </StyledWrapper>
  );
};

export default memo(Loading);
